export default __webpack_public_path__ + "static/media/030208202112102.76efca5e.png";